import { EndpointsExperiments } from './EndpointsExperiments';
import { getEndpointsPrefilling } from './getEndpointsPrefilling';
import { EndpointsSignupClient } from './EndpointsSignupClient';
import { EndpointsSignupCompleted } from './EndpointsSignupCompleted';
import { getFlowEndpointOverrides } from './getFlowEndpointOverrides';
import { getEndpointsSignupInterest } from './getEndpointsSignupInterest';
import { EndpointsEndOfSignup } from './EndpointsEndOfSignup';
import { getEndpointsAuth } from './getEndpointsAuth';
import { EndpointsAvailableHublets } from './EndpointsAvailableHublets';
export const getEndpointConfig = flowKey => {
  return Object.assign({}, getEndpointsAuth(), getEndpointsPrefilling(), EndpointsAvailableHublets, EndpointsSignupClient, EndpointsSignupCompleted, EndpointsEndOfSignup, EndpointsExperiments, getEndpointsSignupInterest(), getFlowEndpointOverrides(flowKey));
};
export const getEndpoint = endpointKey => getEndpointConfig()[endpointKey];
export const setEndpointFetched = endpointKey => {
  const endpoint = getEndpointConfig()[endpointKey];
  if (endpoint) {
    endpoint.fetched = true;
  }
};